// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__sDrWs","title":"Navigation_title__6HeuQ","navButton":"Navigation_navButton__xU6tk"};